import { FC, useEffect } from 'react'
import { useLogOut } from '@user/store/authorization'
import { useLocation } from 'react-router-dom'

function useQuery() {
  return new URLSearchParams(useLocation().search)
}

const useLogoutSSO = () => {
  const logout = useLogOut()
  const query = useQuery()

  useEffect(() => {
    const disabledTypeParam = query.get('deactivateType')
    const disabledType =
      disabledTypeParam !== null && disabledTypeParam !== undefined
        ? isNaN(Number(disabledTypeParam))
          ? disabledTypeParam
          : Number(disabledTypeParam)
        : undefined

    logout(disabledType) // pass number if present, undefined otherwise
  }, [logout, query])
}

const LogoutSSO: FC = () => {
  useLogoutSSO()
  return null
}

export default LogoutSSO
